import React, { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      fromRender: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true, fromRender: true };
  }

  componentDidCatch(error, errorInfo) {
    if (window.__showError) window.__showError(error, errorInfo);
  }

  componentDidMount() {
    window.addEventListener('error', this.handleWindowError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleWindowError);
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  handleWindowError = (event) => {
    if (!event.error || !event.error.stack) return;
    if (event.filename && (
      event.filename.indexOf('chrome-extension://') === 0 ||
      event.filename.indexOf('moz-extension://') === 0 ||
      event.filename.indexOf('safari-extension://') === 0
    )) return;
    event.preventDefault();
    if (window.__showError) window.__showError(event.error);
  };

  handleUnhandledRejection = (event) => {
    if (!event.reason || !(event.reason instanceof Error) || !event.reason.stack) return;
    event.preventDefault();
    if (window.__showError) window.__showError(event.reason);
  };

  render() {
    if (this.state.hasError && this.state.fromRender) {
      return null;
    }
    return this.props.children;
  }
}
